import React, { useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';

import { useStyles } from './styles';

const CARD_ROWS = 6;
const SKELETON_HEADER_KEYS = [0, 1, 2, 3, 4];

export const SkeletonList = ({ rows = 10 }) => {
  const classes = useStyles();
  const seed = useMemo(() => Math.random().toString(36).substr(2, 9), []);
  const rowKeys = useMemo(
    () => Array.from({ length: Math.max(0, rows) }, (_, i) => `row-${seed}-${i}`),
    [rows, seed]
  );

  return (
    <>
      <Paper elevation={0} classes={{ root: classes.headerSkeleton }} role="progressbar">
        <Grid container spacing={4} alignItems="center" wrap="nowrap" justify="space-around">
          {SKELETON_HEADER_KEYS.map(id => (
            <Grid item container wrap="nowrap" justify="space-around" key={`header-cell-${id}`}>
              <Skeleton
                className={classes.circleSkeleton}
                variant="circle"
                width={20}
                height={20}
              />
              <Skeleton variant="rect" width="70%" height={20} />
            </Grid>
          ))}
        </Grid>
      </Paper>

      <div className={classes.rowsContainer} role="progressbar">
        {rowKeys.map(each => (
          <div key={each} className={classes.skeletonRow}>
            {SKELETON_HEADER_KEYS.map(e => (
              <div key={e} className={classes.skeletonItemContainer}>
                <Skeleton height={10} className={classes.skeletonItem} />
              </div>
            ))}
          </div>
        ))}
      </div>
      {rows >= CARD_ROWS && (
        <div className={classes.footerSkeletonBar}>
          <Skeleton width="100%" height={56} />
        </div>
      )}
    </>
  );
};
